export const login = {
    contentLogin: 'APP AIS アカウントでログインできます',
    downloadApp: 'AIS アプリをダウンロード',
    downloadInstructions: 'ダウンロード手順',
    buttonLogin: 'ログイン',
    passwordLabel: 'パスワード',
    title: 'ログイン',
    forGetPassword: 'パスワードを忘れ？',
    register: '登録',
    noAccount: 'アカウントがないのですか？',
};
